/* Castor Hub — adds the page the customer was on (and basket lines on /cart) to WhatsApp, email and
   contact-form messages. Never rendered on the page. (30-10-2026) */
(function () {
  var KEY = 'ch_enquiry_from';
  var SUFFIX = /\s*[–|-]\s*Castor Hub( UK)?\s*$/i;
  var cleanUrl = function () {
    var u = new URL(location.href);
    ['preview_theme_id', '_pos', '_sid', '_ss', '_psq', '_fid', 'pb', 'gclid', 'fbclid'].forEach(function (k) { u.searchParams.delete(k); });
    Array.from(u.searchParams.keys()).forEach(function (k) { if (/^utm_/.test(k)) u.searchParams.delete(k); });
    return u.origin + u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  };
  var title = function () {
    var h = document.querySelector('[data-ch-product-title]') || (location.pathname.indexOf('/products/') > -1 ? document.querySelector('h1') : null);
    var t = h ? h.textContent.trim() : document.title.replace(SUFFIX, '').trim();
    var v = document.querySelector('[data-ch-variant-title]');
    if (v && v.textContent.trim() && !/default title/i.test(v.textContent)) t += ' (' + v.textContent.trim() + ')';
    return t;
  };
  var basket = null;
  var loadBasket = function () {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      basket = c.items.map(function (i) { return '• ' + i.product_title + (i.variant_title && !/default title/i.test(i.variant_title) ? ' (' + i.variant_title + ')' : '') + ' × ' + i.quantity; }).join('\n');
    }).catch(function () {});
  };
  loadBasket();
  document.addEventListener('ch:cart-updated', loadBasket);
  var context = function () {
    var from = null;
    if (/^\/pages\/contact/.test(location.pathname)) { try { from = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {} }
    var t = from ? from.title : title(), u = from ? from.url : cleanUrl();
    return { title: t, url: u, basket: from ? from.basket : basket };
  };
  var isWA = function (href) { return /wa\.me\/|api\.whatsapp\.com/i.test(href); };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var c = context();
    if (isWA(href)) {
      var u = new URL(href, location.href);
      var text = u.searchParams.get('text') || '';
      var add = (c.basket ? 'Basket:\n' + c.basket + '\n' : '') + 'Page: ' + c.title + '\n' + c.url;
      text = text ? text + '\n\n' + add : "Hi, I'm interested in: " + c.title + '\n' + c.url + (c.basket ? '\n\nBasket:\n' + c.basket : '');
      u.searchParams.set('text', text);
      a.setAttribute('href', u.toString());
    } else if (/^mailto:/i.test(href)) {
      var parts = href.split('?'), q = new URLSearchParams(parts[1] || '');
      var body = q.get('body') || '';
      q.set('body', body + '\n\n---\n' + (c.basket ? 'Basket:\n' + c.basket + '\n' : '') + 'Page: ' + c.title + '\n' + c.url);
      if (!q.get('subject')) q.set('subject', 'Enquiry: ' + c.title);
      a.setAttribute('href', parts[0] + '?' + q.toString().replace(/\+/g, '%20'));
    } else if (/\/pages\/contact/.test(href) && !/^\/pages\/contact/.test(location.pathname)) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ title: title(), url: cleanUrl(), basket: basket })); } catch (err) {}
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector('[name^="contact["]')) return;
    if (f.querySelector('[name="contact[Enquiry from page]"]')) return;
    var c = context();
    var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
    add('contact[Enquiry from page]', c.title + ' — ' + c.url);
    if (c.basket) add('contact[Basket]', c.basket);
  }, true);
})();
